<template>
    <div class="appHeader">
        <div class="appLogo cursor-pointer" @click="dashboard">
            {{ siteInfo.SiteName }}
        </div>
        <el-row class="left-panel">
            <el-col :span="12">
                <el-tabs class="modulesHeader" :model-value="currentModule" v-if="showModules" @tab-click="changeModule">
                    <el-tab-pane v-for="item in modules" 
                        :key="item.ModuleId"
                        :label="item.ModuleName" 
                        :name="item.ModuleId">
                        <template #label>
                            <span class="custom-tabs-label">
                                <span class="el-icon module-icon"><i :class="item.IconClass" /></span>
                                <span>{{ item.ModuleName }}</span>
                            </span>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="12" class="userTool">              
                <el-dropdown class="appUser">
                    <span class="cursor-pointer">
                        <el-avatar size="small"><el-icon><user-filled /></el-icon></el-avatar>
                        <span style="padding-left:0.5rem">{{ userInfo.NickName }}</span>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item @click="changeUserInfo">
                                <el-icon><post-card /></el-icon>
                                个人中心
                            </el-dropdown-item>
                            <el-dropdown-item @click="logOff">
                                <el-icon><switch-button /></el-icon>
                                退出系统
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <notification-center></notification-center>
                <site-search></site-search>
            </el-col>
        </el-row>
    </div>
</template>


<style scoped>
    
    .userTool{
        display: flex;
        line-height: var(--el-header-height);
        flex-direction: row-reverse;
        align-items: flex-end;
    }
    
    .appHeader{
        display: flex;
    }
    .appLogo{
        padding-left: 20px;
        width: 240px;
        flex-shrink: 0;
        flex-grow: 0;
    }
    .left-panel{
        flex-grow: 1;
        margin-left: auto;
        display: -webkit-flex; 
        display: flex;
        align-items: center;
        justify-items: center;
        height: var(--el-header-height);
        line-height: 40px;
        width: calc(100% - 260px);
    }
    .appUser{
        float: right;
        margin-right:1rem;
        
    }
    .module-icon{
        vertical-align: middle;
        margin-right: 5px
    }
    .modulesHeader{
        padding:0 10px;
    }
</style>

<style>
    .cursor-pointer{
        cursor:pointer;
    }
    .modulesHeader .el-tabs__nav-wrap::after{
        height:0px !important
    }
    .modulesHeader .el-tabs__header{
        margin:0px !important
    }
</style>

<script>
    import { SwitchButton,UserFilled,Postcard, Expand, Fold } from '@element-plus/icons-vue'
    import { logOff, getCSRF } from "../apis/httpHelper"
    import { RouterMeta } from '../route'
    import NotificationCenter from "./Notification/NotificationCenter.vue"
    import SiteSearch from "./SiteSearch/SiteSearch.vue"

    export default{
        data:function(){
            return {
                activeName:""
            }
        },
        
        computed:{
            userInfo:function(){
                return this.$store.state.userInfo;
            },
            siteInfo:function(){
                return this.$store.state.siteInfo;
            },
            modules:function(){
                return this.$store.state.modules;
            },
            showModules:function(){
                return this.modules.length > 1;
            },
            currentModule:function(){
                return this.$store.state.currentModule;
            },
            menuExpandState:function(){
                return this.$store.state.menuExpandState;
            },
            noticeCount:function(){
                return this.$store.state.notificationUnReadTotal;
            }
        },
        components:{
            'switch-button':SwitchButton,
            'user-filled':UserFilled,
            'post-card':Postcard,
            'fold':Fold,
            'expand':Expand,
            "notification-center":NotificationCenter,
            'site-search':SiteSearch
        },
        methods:{
            logOff:function(){
                logOff()
                    .then(x=> getCSRF())
                    .then(csrf=>{
                        this.$store.commit("SetVerification", csrf.Result);
                        this.$store.commit("LogOut", true);
                        this.$router.push(RouterMeta.login.path);
                    }).catch(x=>{
                        console.log(x);
                        ElMessage.error(x.ErrorMessages[0].ErrorMessage);
                });
            },

            toggleMenuExpandState:function(){
                this.$store.commit("ToggleMenuState");
            },

            changeModule:function(Module){
                let moduleMenus = this.$store.state.flatMenuItems.filter(x=>x.CurrentModule == Module.props.name);
                this.$router.push(moduleMenus[0].Path);
            },

            changeUserInfo:function(){

            },

            dashboard:function(){
                this.$router.push("/")
            }
        }
    }
</script>

